export default __webpack_public_path__ + "static/media/lock-small.e307e66c.svg";